var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'spinner-container': true, 'small': _vm.small, 'inline': _vm.inline}},[_c('div',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }